import { scarpaGray500, spanishViridian500 } from '@habitech/shared';
import styled from 'styled-components';

export const ProducsSelectableContainer = styled.div`
    display: grid;
    gap: 1rem;

    .title {
        grid-column: 1 / -1;
        font-size: 16px;
        font-weight: 600;
        color: ${spanishViridian500};
        .quantity {
            font-size: 13px;
            font-weight: 500;
            color: ${scarpaGray500};
        }
    }

    .products-container {
        grid-column: 1 / -1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    .product:only-of-type {
        grid-column: 1 / -1;
    }
`;